// /billing — real route (design doc's G2). The original (app/billing/page.tsx)
// is already a pure `'use client'` page with no server auth gate — it reads
// `useAuth()` from Clerk itself and fetches `/api/stripe/portal` (GET, ported
// at apps/server/src/routes/stripe.ts) for the plan/credit summary, and posts
// to the same endpoint to open the Stripe billing portal. No server DB reads,
// so this is a pure mount, same pattern as routes/library.tsx. Registered
// into the route tree from routes/agents.tsx under the `_authed` guard.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authedRoute } from './guards';

const BillingPage = lazy(() => import('@/app/billing/page'));

export const billingRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/billing',
  component: BillingPage,
});
